<template>
  <search-layout class="proposal-certify" :showHotline="false">
    <div slot="header" class="header">
      <div class="title">即将开始签署电子投保单</div>
      <div class="steps">
        <div class="step">
          <div class="label">1</div>
          <div>实名验证核实身份</div>
        </div>
        <div class="step">
          <div class="label">2</div>
          <div>电子签名完成签署</div>
        </div>
      </div>
    </div>
    <page-status :loading="loading">
      <div class="auth-content">
        <div class="auth-title">输入证件号码后4位</div>
        <div class="verify-code">
          <van-password-input
            :gutter="16"
            :mask="false"
            :length="maxLength"
            :value="code"
            :focused="focused"
          />
          <input
            class="input-code"
            type=""
            :maxlength="maxLength"
            v-model="code"
            @focus="focused = true"
            @blur="focused = false"
          />
        </div>
        <div class="btn" @click="handleSubmit()">立即认证</div>
      </div>
    </page-status>
  </search-layout>
</template>

<script>
import { Toast } from 'vant';
import SearchLayout from '@/layouts/SearchLayout';
import PageStatus from '@/components/PageStatus';
import * as services from '@/services';
import { bindRecord } from '@/core/recorder';

export default {
  components: {
    SearchLayout,
    PageStatus,
  },

  data() {
    return {
      loading: false,
      code: '',
      focused: false,
      maxLength: 4,
    };
  },

  created() {
    const token =
      this.$route.query.authToken || window.localStorage.getItem('authToken');
    window.localStorage.setItem('authToken', token);
    const { query } = this.$route;
    const { businessNo, mobile } = query;

    // 绑定用户
    if (businessNo && mobile) {
      bindRecord({ userId: businessNo + '_' + mobile });
    }

    window.localStorage.setItem(`${businessNo}`, window.location.href);
    services.authShift(businessNo).then(res => {
      const { content } = res;
      const { signUrl, signStatus, original } = JSON.parse(content);
      if (original === '1') {
        return;
      } else if (signStatus === '0') {
        const newUrl = token ? `${signUrl}&authToken=${token}` : signUrl;
        window.location.href = newUrl;
      }
    });
  },
  methods: {
    handleSubmit() {
      const { businessNo, mobile } = this.$route.query;
      const idCode = this.code;

      if (idCode.length !== this.maxLength) {
        Toast.fail('请输入正确的证件号码后4位');
        return;
      }

      Toast.loading({
        message: '正在验证',
        forbidClick: true,
        duration: 0,
      });

      services.checkIdCode(businessNo, mobile, idCode).then(res => {
        const { businessNo, mobile } = this.$route.query;
        this.$router.push({
          path: '/proposal-sign',
          query: { businessNo, mobile },
        });
        Toast.clear();
      });
    },
  },

  watch: {
    code(value) {
      this.code = value.slice(0, this.maxLength).replace(/[\W|_]/g, '');
    },
  },
};
</script>

<style lang="less">
.proposal-certify {
  .header {
    .title {
      font-size: 20px;
    }

    .steps {
      margin-top: 16px;
      .step {
        display: flex;
        align-items: center;
        font-size: 12px;
        margin-top: 8px;

        .label {
          width: 15px;
          height: 15px;
          background-color: rgba(255, 255, 255, 0.8);
          line-height: 15px;
          text-align: center;
          font-size: 10px;
          color: #169dba;
          border-radius: 50%;
          margin-right: 8px;
        }
      }
    }
  }

  .auth-content {
    padding: 12px 12px;
    text-align: center;

    .auth-title {
      color: #4a4a4a;
      font-size: 24px;
    }

    .verify-code {
      margin: 24px 16px;
      position: relative;

      .van-password-input {
        li {
          border-radius: 8px;
          border: 1px solid #dcdcdc;
        }
      }

      .input-code {
        position: absolute;
        left: 0;
        top: 0;
        width: 100%;
        height: 100%;
        border: 0;
        outline: none;
        opacity: 0;
      }
    }

    .btn {
      background-image: linear-gradient(136deg, #3a91ec 0%, #426ed9 100%);
      box-shadow: 0rpx 16rpx 30rpx -20rpx #4677d9;
      width: 90%;
      height: 48px;
      line-height: 48px;
      margin: 80px auto 48px;
      border-radius: 4px;
      color: #fff;
    }
  }
}
</style>
